import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function searchQuizzes(fetchParams, requestKey, page) {
  return standardApiRequestAction({
    path: '/api/v1/quizzes/search',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
  });
}

export function updateQuiz(id, params) {
  return standardApiRequestAction({
    path: `/api/v1/quizzes/${id}`,
    method: 'patch',
    body: params,
  });
}

export function createQuiz(params) {
  return standardApiRequestAction({
    path: '/api/v1/quizzes',
    method: 'post',
    body: params,
  });
}

export function deleteQuiz(id) {
  return standardApiRequestAction({
    path: `/api/v1/quizzes/${id}`,
    method: 'delete',
    destroy: { quizzes: [id] },
  });
}

export function fetchQuiz(id, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/quizzes/${id}`,
    requestKey,
    body: fetchParams,
  });
}

export function fetchQuizResults(quizId, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/quizzes/${quizId}/results`,
    requestKey,
    body: fetchParams,
  });
}

export function fetchQuizUsers(quizId, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/quizzes/${quizId}/users`,
    requestKey,
    body: fetchParams,
  });
}

export function fetchLSACTest(testId, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/lsat/practice_tests/${testId}`,
    requestKey,
  });
}
